import { NmeaConfigField } from '../datapool/NmeaConfigField'
import {dataLimitMode} from './GraphUiState'

//Liste des mode 
export class GraphNmeaState {

    public typeUiid:string
    public refresh:boolean
    public fields:Array<{nmea:string,field:NmeaConfigField}>    
    public pointSize:number
    public dataLimit:string
    public zoom:string
    

    constructor({                
                typeUiid="detail", //detail ou global
                refresh=false,   
                pointSize=2,
                zoom="ZoomXAxis",
                dataLimit=dataLimitMode.LAST_12H,             
                fields=[]
            } = {}) {  
        this.typeUiid = typeUiid
        this.refresh = refresh        
        this.fields = fields
        this.pointSize = pointSize
        this.dataLimit = dataLimit
        this.zoom = zoom     
    }
}